import React, { useState, useEffect } from 'react';
import { useRouteMatch, useHistory, useParams  } from 'react-router-dom';
import { useFetchAppsByDeveloperIdQuery, } from '../../redux/api/appMarket-api-slice';
import { PageInfo } from '../../components/Header/PageInfo';
import { useAppCollections } from '../../contexts/providers/collection';
import { Filters, getFilterSortInfoFromFilterKey } from '../../components/Common/FilterDropDown/filters';
import { FilterDropDown } from '../../components/Common/FilterDropDown';
import { removeMatchingElementFromArray } from '../../utils/helpers';
import { generateRoute } from '../../utils/location';
import { AppsByDeveloperIdParameters } from '../../redux/api/types';
import { AppMarketPageIdentifier } from '../../AppRoutes';
import { APP_GRID_LOAD_MORE_CONFIG, AppGrid } from '../../components/AppGrid';
import { SetPageTitle } from '../../components/Common/SetPageTitle';
import { useRatingsAndReviews } from '../../contexts/providers/ratings-reviews';

let defaultFilterKey = Filters.MostPopular;

export const DeveloperDetailsPage = (): JSX.Element => {
  let AllowedFilters: Filters[] = [Filters.MostPopular, Filters.TopRated, Filters.Newest ];

  let history = useHistory();

  const ratingsAndReviewsFeatureFlag = useRatingsAndReviews();

  let { filterKey } = useParams<{ filterKey: Filters }>();
  const [limit, setLimit] = useState<number>(APP_GRID_LOAD_MORE_CONFIG.maxEntriesPerPage as number + 1);


  let sort = getFilterSortInfoFromFilterKey((filterKey) || defaultFilterKey);

  const [developerName, setDeveloperName] = useState<string | undefined>();

  const {params: { developerId },} = useRouteMatch<{ developerId: string }>();

  const queryParams: AppsByDeveloperIdParameters = {
    devId: developerId?.toString() ?? '',
    limit
  };

  if (sort) queryParams.sorts = [sort];

  const { data: appsByDeveloperId, isLoading, isFetching } =
    useFetchAppsByDeveloperIdQuery(queryParams);

  const { collections } = useAppCollections();

  const filterChangeHandler = (filters: Filters) => {
    history.push(
      generateRoute(AppMarketPageIdentifier.DeveloperApps, [
        developerId?.toString() ?? '',
        filters
      ]),
    );
  };

  useEffect(() => {
    const devName = collections.map(col =>
      col.carouselApps.map(apps => apps.developer).find(dev => dev.id === developerId),
    );
    setDeveloperName(devName.map(dev => dev?.name).find(developerName => developerName !== undefined));
  }, [isLoading, appsByDeveloperId, collections, developerId]);

  const changeLimit = (apiLimit: number) => {
    if (apiLimit !== limit) setLimit(apiLimit);
  }

  if (!ratingsAndReviewsFeatureFlag.enabled){
    removeMatchingElementFromArray<Filters>(AllowedFilters, Filters.TopRated);
    let test = Filters.TopRated;
    if (test === filterKey) history.replace(generateRoute(AppMarketPageIdentifier.DeveloperApps, [developerId?.toString() ?? '', defaultFilterKey]));
  }


  return (
    <>
      <SetPageTitle/>
      <PageInfo hideDescription={true} title={developerName} />
      <FilterDropDown
        onChangeHandlerCallback={filterChangeHandler}
        allowedFilters={AllowedFilters}
        selectedFilter={(filterKey) || defaultFilterKey}
      />
      <AppGrid apps={appsByDeveloperId} isLoading={isLoading} isFetching={isFetching} setApiLimit={changeLimit}/>
    </>
  );
};
